export default {
  homePage: 'Home page!',
};
